import React, { Component } from "react";
import { connect } from "react-redux";
import { UserProfile } from "../../Redux/Types/profile";
import { toggleDrawer } from "../../Redux/Actions/drawer";
import classname from "classnames";

import "./style.css";

type IProps = {
  history: any;
  location: any;
  drawer: boolean;
  user: UserProfile;
  logout: () => void;
  toggleDrawer: () => void;
};
type IState = { activeTab: string; logoutModal: boolean };
class SideBar extends Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      activeTab: "/",
      logoutModal: false,
    };
  }

  handleChangeTab = (path: string) => {
    this.setState({ activeTab: path });
    this.props.history.push(path);
    if (window.innerWidth <= 768 && this.props.drawer) {
      this.props.toggleDrawer();
    }
  };

  handleBackdropClick = () => {
    if (window.innerWidth <= 768 && this.props.drawer) {
      this.props.toggleDrawer();
    }
  };

  toggleLogoutModal = () => {
    this.setState({ logoutModal: !this.state.logoutModal });
  };
  render() {
    const { drawer } = this.props;
    var activeSideBar = this.state.activeTab;
    if (this.props.location.pathname !== activeSideBar)
      activeSideBar = this.props.location.pathname;
    return (
      <>
      {drawer && (
        <div className="sidebarBackdrop" onClick={this.handleBackdropClick} />
      )}
      <div
        className={`sidebarMain ${drawer ? "MainDrawer" : "MainDrawerHide"}`}
      >
        <div
          className={classname({
            OptionIcons: true,
            dashboardOption: true,
            activeSideBar: activeSideBar === "/",
          })}
          onClick={() => {
            this.handleChangeTab("/");
          }}
        >
          <i className="fas fa-tachometer-alt dashboard" style={iconStyle} />
          <span className="IconNameStyling">Dashboard</span>
        </div>
        <div
          className={classname({
            OptionIcons: true,
            activeSideBar: activeSideBar === "/videos",
          })}
          onClick={() => this.handleChangeTab("/videos")}
        >
          <i className="fab fa-microsoft" style={iconStyle} />
          <span className="IconNameStyling">My Videos</span>
        </div>
        <div
          className={classname({
            OptionIcons: true,
            activeSideBar: activeSideBar === "/inbox",
          })}
          onClick={() => this.handleChangeTab("/inbox")}
        >
          <i className="fas fa-inbox" style={iconStyle} />
          <span className="IconNameStyling">Replies</span>
        </div>

        <div
          className={classname({
            OptionIcons: true,
            activeSideBar: activeSideBar === "/agent",
          })}
          onClick={() => this.handleChangeTab("/agent")}
        >
          <i className="fas fa-robot" style={iconStyle} />
          <span className="IconNameStyling">AI Agent</span>
        </div>

        <div
          className={classname({
            OptionIcons: true,
            activeSideBar: activeSideBar === "/avatars",
          })}
          onClick={() => this.handleChangeTab("/avatars")}
        >
          <i className="fas fa-user-circle" style={iconStyle} />
          <span className="IconNameStyling">Avatars</span>
        </div>

        <div
          className={classname({
            OptionIcons: true,
            activeSideBar: activeSideBar === "/configuration",
          })}
          onClick={() => this.handleChangeTab("/configuration")}
        >
          <i className="fas fa-users-cog" style={iconStyle} />
          <span className="IconNameStyling">Configuration</span>
        </div>

        <div
          className={classname({
            OptionIcons: true,
            activeSideBar: activeSideBar === "/assetlibrary",
          })}
          onClick={() => this.handleChangeTab("/assetlibrary")}
        >
          <i className="fas fa-folder" style={iconStyle} />
          <span className="IconNameStyling">Asset Library</span>
        </div>

        <div
          className={classname({
            OptionIcons: true,
            activeSideBar: activeSideBar === "/music",
          })}
          onClick={() => this.handleChangeTab("/music")}
        >
          <i className="far fa-play-circle" style={iconStyle} />
          <span className="IconNameStyling">Music</span>
        </div>
      </div>
      </>
    );
  }
}
const iconStyle = {
  fontSize: "14px",
  width: "1.5em",
  display: "inline-block",
  color: "#FFFFFF",
  cursor: "pointer",
};
const mapStateToProps = (state: any) => {
  return {
    user: state.profile.user,
    drawer: state.drawer.drawer,
  };
};
const mapDispatchToProps = (dispatch: any) => {
  return {
    toggleDrawer: () => dispatch(toggleDrawer()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
